<header>
  <h1>{{ type }} Admin</h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>

<section class="filters">
  <mat-button-toggle-group
    #typeFilter="matButtonToggleGroup"
    (change)="setType(typeFilter.value)"
    [value]="defaultType"
    >
    <mat-button-toggle disabled value="*">Type:</mat-button-toggle>
    @for (toggle of toggles; track toggle) {
      <mat-button-toggle [value]="toggle.value">
        <!-- <mat-icon>{{toggle.icon}}</mat-icon> -->
        {{toggle.label}}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</section>
<section>
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!CategoryProducts?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No events found.
        </mat-card-content>
      </mat-card>
    }
    @if (!!CategoryProducts?.length) {
      <table mat-table [dataSource]="DataSource" class="categories">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let row">{{ row.title }}</td>
        </ng-container>
        <ng-container matColumnDef="from_price">
          <th mat-header-cell *matHeaderCellDef>Price (from)</th>
          <td mat-cell *matCellDef="let row">@if (row.from_price !== '0.00') {
            <span>£{{ row.from_price }}</span>
          }</td>
        </ng-container>
        <ng-container matColumnDef="to_price">
          <th mat-header-cell *matHeaderCellDef>Price (to)</th>
          <td mat-cell *matCellDef="let row">@if (row.to_price !== '0.00') {
            <span>£{{ row.to_price }}</span>
          }</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions">Actions</th>
          <td mat-cell *matCellDef="let row" class="actions"></td>
        </ng-container>
      </table>
      @if (PageEvent) {
        <mat-paginator
          (page)="DataSource.loadWithPageEvent($event)"
          [length]="PageEvent.length"
          [pageIndex]="PageEvent.pageIndex"
          [pageSize]="PageEvent.pageSize"
        ></mat-paginator>
      }
    }
  }
</section>
